import { type AgencyId } from "@inrev/common";

export const adminAgencyAccountPreviewsQueryKey = (agencyId: AgencyId) =>
	["previews", "admin-agency-accounts", agencyId] as const;

export const adminAgencyPreviewsQueryKey = () => ["previews", "admin-agencies"] as const;

export const adminAgencyQueryKey = (agencyId: AgencyId) => ["adminAgency", agencyId] as const;

export const adminAgentPreviewsQueryKey = (agencyId?: AgencyId) =>
	agencyId
		? (["previews", "admin-agents", agencyId] as const)
		: (["previews", "admin-agents"] as const);
